// Stripe Options
export const stripeOptions = {
	// Stripe public key - TEST
	pkTest: 'pk_test_51NSJ2hBFkGtmvNorWCCjX2ohvAkuAWIrRKKXudwbGKv9nkWyUo4ipjAqlFPu2ZEm7fIUAd4jMGTpK9ccw0DwZgDj00v2C7S9oG',
	// Stripe public key - LIVE
	pkLive: 'pk_live_51NSJ2hBFkGtmvNorktHI8mEkKsmq5mxb3aDcFBqqJkaB3U8FrpUDrLdhvJviKpiTue7UGF3TX2BxIBDAYuYoiAFE00SCoXiMyp',
};
